export const namespaced = true;

export const state = {
    pages: [],
}

export const mutations = {
    FETCH_PAGES(state, pages) {
        state.pages = pages;
    },
}

export const actions = {

    async fetch({ commit, state, dispatch }) {
        try {
            const res = (await axios.get(`/api/pages`)).data;
            commit('FETCH_PAGES', res.data.pages);
            return res.data.pages;
        } catch (error) {
            const notification = {
                element: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    }

}
